import { CREATIVE_ID } from 'hooks';
import { ButtonCollection } from '../../buttonCollection';
import type { KeyVisualActionsProps } from '../types';

/**
 * KeyVisualActions component - Renders action buttons within a key visual.
 *
 * Wraps the ButtonCollection component with key visual-specific creative ID tracking.
 *
 * @param props - Action buttons configuration and device information
 * @returns Rendered button collection with key visual creative ID
 *
 * @example
 * // Single action button
 * <KeyVisualActions
 *   device="desktop"
 *   buttons={[
 *     {
 *       text: 'Shop Now',
 *       url: '/products',
 *       type: 'primary',
 *     },
 *   ]}
 * />
 *
 * @example
 * // Multiple action buttons
 * <KeyVisualActions
 *   device="mobile"
 *   buttons={[
 *     { text: 'Browse Products', url: '/shop', type: 'primary' },
 *     { text: 'Learn More', url: '/about', type: 'secondary' },
 *   ]}
 *   constants={{ buttonLabel: 'Click here' }}
 * />
 */
function KeyVisualActions(props: KeyVisualActionsProps) {
  return <ButtonCollection {...props} creativeId={CREATIVE_ID.KEY_VISUAL}></ButtonCollection>;
}

export { KeyVisualActions };
